import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import TabBar from "@/shared/components/Tabs/TabBar";

import { getOptionKey } from "@/shared/utils/select";

import styles from "./Tabs.module.scss";

const Tabs = ({
  tabVariant,
  tabs,
  value,
  className = "",
  activeTabClassName,
  innerClassName = "",
  tabClassName = "",
  onChangeTab,
  children,
}) => {
  if (!tabs) {
    return null;
  }

  const indexActive = tabs.findIndex((t) => getOptionKey(t) === value);

  return (
    <div className={classnames(styles["base-tabs"], className)}>
      <TabBar
        tabVariant={tabVariant}
        className={innerClassName}
        tabClassName={tabClassName}
        activeTabClassName={activeTabClassName}

        current={value}
        options={tabs}
        onSelectTab={onChangeTab}
      />

      {children &&
        children.map((child, index) => {
          return (
            <div
              key={index}
              data-id={index}
              role="tabpanel"
              className={classnames(styles["base-tabs__body"], tabClassName)}
              style={index === indexActive ? null : { display: "none" }}
            >
              {child}
            </div>
          );
        })}
    </div>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.array,
  activeIndex: PropTypes.any,
  className: PropTypes.string,
  activeTabClassName: PropTypes.string,
  innerClassName: PropTypes.string,
  tabClassName: PropTypes.string,
  setActiveTabIndex: PropTypes.func,
  children: PropTypes.node,
};

export default Tabs;
